module.exports = __webpack_public_path__ + "media/images/e-kvitok/train_bg-affa4b80f5cf3cc90aa0f3e29278b347.svg";